<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
                <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
                <ion-title>Usage Report</ion-title>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <UsageReport />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import UsageReport from "@/components/corporate/usageReport.vue";
import { IonButtons, IonBackButton, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
    name:  'usageReport',
    components: {
        UsageReport, IonBackButton, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent
    },
    data() {
        return {

        }
    },
    methods: {
        navigatePreviousPage() {
            this.$router.go(-1)
        }
    }
})
</script>